import { CheckCircleOutlined, CloseOutlined, WarningOutlined } from '@ant-design/icons';
import { Flex, message } from 'antd';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

function useMessages() {
  const [messageApi, contextHolder] = message.useMessage();

  const handleShowSuccess = useCallback(() => {
    messageApi.open({
      type: 'success',
      content: <FormattedMessage {...messages.voucherAppliedMessage} />,
      icon: (
        <CheckCircleOutlined
          style={{ cursor: 'pointer', color: '#027A48', fontSize: 20 }}
          onClick={() => messageApi.destroy()}
        />
      ),
      className: 'voucher-applied-message',
    });
  }, [messageApi]);

  const handleShowError = useCallback(() => {
    messageApi.open({
      type: 'error',
      content: (
        <>
          <Flex vertical>
            <FormattedMessage {...messages.voucherErrorMessage} />
          </Flex>
          <CloseOutlined
            style={{ marginLeft: 4, cursor: 'pointer', fontSize: 20 }}
            onClick={() => messageApi.destroy()}
          />
        </>
      ),
      icon: (
        <WarningOutlined
          style={{ cursor: 'pointer', color: '#F5CE47', fontSize: 20 }}
          onClick={() => messageApi.destroy()}
        />
      ),
      className: 'voucher-error-message',
    });
  }, [messageApi]);

  return { contextHolder: contextHolder, handleShowSuccess: handleShowSuccess, handleShowError: handleShowError };
}

export default useMessages;
